import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  className?: string;
}
export default function Logo({
  className = ''
}: LogoProps) {
  return <Link to="/" className="flex items-center" data-id="element-117">
      <span className={`text-2xl font-bold font-heading ${className || 'text-navy'}`} data-id="element-118">
        Artisanfix
      </span>
    </Link>;
}